// sidemenu.service.js

import axiosInstance from "../axiosInstance";

export const sidemenuService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/sidemenu", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit = 15, skip = 0, search, filter_query) => {
    try {
      let query = [];
      if (limit != null) query.push(`$limit=${limit}`);
      if (skip != null) query.push(`$skip=${skip}`);
      if (search) query.push(`title[$search]=${search}`);
      if (filter_query) query.push(filter_query);
      let api = `/sidemenu?${query.join("&")}`;
      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/sidemenu/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/sidemenu/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchColumnValues: async (columnName, search, limit = 15, skip = 0) => {
    try {
      let api = `/sidemenu?$select=${columnName}&$limit=${limit}&$skip=${skip}`;
      if (search) {
        api += `&${columnName}[$search]=${search}`;
      }

      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
